import type { SuiteChromeUser } from "./types";

/**
 * True if the user may open the Admin console.
 *
 * Three ways in, and the third is the one that was missing: a user whose
 * administrative rights come from an **org** role rather than a system role.
 * `admin_scopes` is populated from `User.system_roles` only, so somebody made
 * an Admin of their organization — an OrgAdminAssignment onto the org's Admin
 * OrgRole — held every org scope that role grants and still had no way into
 * the console, because the tile that opens it only ever looked at the system
 * list. That is the "I made them an admin and the icon never appeared" report.
 *
 * `orgAdminPermissions` deliberately excludes module access (`*:access`): the
 * default Member role grants those to every user, so including them would put
 * the Admin tile in front of the whole organization.
 */
export function userCanAccessAdminApp(user: SuiteChromeUser | null): boolean {
  if (!user) return false;
  if (user.isSuperAdmin) return true;
  if ((user.adminPermissions?.length ?? 0) > 0) return true;
  return (user.orgAdminPermissions?.length ?? 0) > 0;
}
